import { getServiceUrl } from './api.config';
import { ApiClientOptions } from './types/api';
import ApiClient from './utils/ApiClient';

export default class IndexerApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('eda'), options);
  }
}
